// extracted by mini-css-extract-plugin
export default {"imageWrapper":"RE-z","hovered":"SE-z","hoverImage":"TE-z","mainImage":"UE-z","imageNoBackground":"VE-z","fullSizeImage":"WE-z"};